import { config } from '@config/index'

export const isLocal = config.environment.toLocaleUpperCase() === 'LOCAL'
export const isDev = config.environment.toLocaleUpperCase() === 'DEV'
export const isUat = config.environment.toLocaleUpperCase() === 'UAT'
export const isPre = config.environment.toLocaleUpperCase() === 'PRE'
export const isSit = config.environment.toLocaleUpperCase() === 'SIT'
export const isCit = config.environment.toLocaleUpperCase() === 'CIT'
export const isProd = config.environment.toLocaleUpperCase() === 'PROD'

export const isNonProd = isDev || isUat || isPre || isSit || isCit
